import { createTheme, Theme } from "@mui/material/styles";

const colors = {
    "light-green": "#5ac36b",
    grey: "#e2e2e2",
};

const getTheme = (dark: boolean): Theme =>
    createTheme({
        palette: {
            primary: {
                main: colors["light-green"],
            },
            secondary: {
                main: colors.grey,
                // @ts-expect-error this is added from us
                footer: "#656565",
            },
            background: {
                default: "#303030",
                // @ts-expect-error this is added from us
                outline: "#3d3d3d",
                paper: "#3d3d3d",
                overlay: "#272727",
                tooltip: "#242424",
                work: "#13a7ad",
                collaboration: "#F24AE1",
                wellbeing: "#F2994A",
                overall: "#59C36A",
                toggleButtonUnselected: "#555555",
                inactiveIcons: "#4F4F4F",
                noIntegrationIcons: "#838383",
                bugs: "#F2994A",
                features: "#15ADB2",
                tasks: "#6C63F0",
            },
            medals: {
                bronze: "#BF7805",
                silver: "#a9a9a9",
                gold: "#8e7039",
                platinum: "#998192",
            },
            missions: {
                easy: "#8bc34a",
                moderate: "#009688",
                high: "#ff5722",
            },
            flow: {
                high: "#D44DAD",
                low: "#8564E9",
                neutral: "#e2e2e2",
            },
            mode: dark ? "dark" : "light",
        },
        sizes: {
            maxPageWidth: 1280,
        },
        typography: {
            fontFamily: `'Poppins', Arial, Helvetica, sans-serif`,
        },
        components: {
            MuiCssBaseline: {
                styleOverrides: {
                    ".recharts-brush .recharts-brush-texts": {
                        display: "none",
                    },
                },
            },
            MuiInputBase: {
                styleOverrides: {
                    root: {
                        fontSize: "13px",
                    },
                },
            },
            MuiAccordion: {
                styleOverrides: {
                    root: {
                        border: "none",
                        "&:before": {
                            display: "none",
                        },
                    },
                },
            },
        },
    });

export default getTheme;
